<template>
    <div class="container-scroller">
        <Loader v-if="loading" :show-full="true" loading-text="Logging in..."/>
        <div class="container-fluid page-body-wrapper full-page-wrapper">
            <div class="row w-100">
                <div class="col-10 col-md-8 d-xs-none">
                    <img src="https://source.unsplash.com/1000x1000?tech,robots,ai" class="resp"/>
                </div>
                <div class="col-12 col-md-4">
                    <div class="auth-form-light text-left p-5" style="margin-top: 100px">
                        <div class="brand-logo" >
                            <img src="../../assets/boflogo.png" style="width: 180px">
                        </div>
                        <h4 style="margin-top: 30px">Hello! let's get started</h4>
                        <h6 class="font-weight-light">Sign in to continue.</h6>
                        <form class="pt-3" @submit.prevent="login">
                            <div class="form-group">
                                <input type="email" class="form-control form-control-lg" id="exampleInputEmail1"
                                       placeholder="Email" v-model="email" required>
                            </div>
                            <div class="form-group">
                                <input type="password" class="form-control form-control-lg"
                                       id="exampleInputPassword1" placeholder="Password" v-model="password"
                                       required>
                            </div>
                            <div class="mt-3">
                                <button class="btn btn-block btn-gradient-primary btn-lg font-weight-bold  auth-form-btn"
                                        href="">SIGN IN
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!--<div class="content-wrapper d-flex align-items-center auth">-->
            <!--<div class="row w-100">-->
            <!--<div class="col-lg-4 mx-auto">-->
            <!--<div class="auth-form-light text-left p-5">-->
            <!--<div class="brand-logo">-->
            <!--&lt;!&ndash;<img src="../../assets/images/providus.png">&ndash;&gt;-->
            <!--</div>-->
            <!--<h4>Hello! let's get started</h4>-->
            <!--<h6 class="font-weight-light">Sign in to continue.</h6>-->
            <!--<form class="pt-3" @submit.prevent="login">-->
            <!--<div class="form-group">-->
            <!--<input type="text" class="form-control form-control-lg" id="exampleInputEmail1"-->
            <!--placeholder="Username" v-model="email" required>-->
            <!--</div>-->
            <!--<div class="form-group">-->
            <!--<input type="password" class="form-control form-control-lg"-->
            <!--id="exampleInputPassword1" placeholder="Password" v-model="password"-->
            <!--required>-->
            <!--</div>-->
            <!--<div class="mt-3">-->
            <!--<button class="btn btn-block btn-gradient-primary btn-lg font-weight-medium auth-form-btn"-->
            <!--href="">SIGN IN-->
            <!--</button>-->
            <!--</div>-->
            <!--</form>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!--</div>-->
            <!-- content-wrapper ends -->
        </div>
        <!-- page-body-wrapper ends -->
    </div>
</template>
<!-- container-scroller -->

<script>
    import Loader from "../../components/Loader/Loader";
    import {mapActions} from 'vuex';
    import router from '../../router'

    export default {
        name: 'Login',
        components: {Loader},
        data: function () {
            return {email: '', password: '', loading: false}
        },
        methods: {
            ...mapActions({Login: 'LOGIN'}),
            async login() {
                this.loading = true;
                await this.Login({
                    email: this.email,
                    password: this.password
                }).then(function () {
                    router.push({name: 'dashboard'});
                }).catch((error) => {
                   // alert(error);
                    this.$toastr.error(error.message, "Login Failed!", {timeOut: 5000});
                });
                this.loading = false;
            }
        }
    }

</script>
<style scoped>
    .resp{
        height: 100vh;
        width: 100%;
        object-fit: cover;
        overflow: hidden;
    }
    .auth-form-btn{
        padding: 23px 15px;
    }
</style>
